import { Cross } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { EmptyState } from '../../components/EmptyState'
import { EmptyStateProps } from '../../types'

interface Props {
  filtersApplied: boolean
  emptyStateProps: EmptyStateProps
}

export const EmptyStateTable = ({ filtersApplied, emptyStateProps }: Props) => {
  if (filtersApplied) {
    return (
      <EmptyState
        title={i18n.t('finance.financial_workspace.breakdown_table.search.no_results.title')}
        description={i18n.t(
          'finance.financial_workspace.breakdown_table.search.no_results.description'
        )}
        icon={Cross}
      />
    )
  }

  return <EmptyState title={emptyStateProps.title} description={emptyStateProps.description} />
}
